export class ScenarioMeta {

  public static fromDto(dto: any): ScenarioMeta {
    const constructorParams = { ...dto };
    constructorParams.startDate = dto.startDate && new Date(dto.startDate);
    return new ScenarioMeta(constructorParams);
  }

  public uuid: string | undefined;
  public name: string | undefined;
  public updatedAt: Date | undefined;
  public configuration: string | undefined;
  public description: string | undefined;
  public hasEnergyEfficiency: boolean | undefined;
  public progress: number | undefined; // not fed
  public sizing: any; // as in DTO
  public report: any; // as in DTO

  constructor(options?: any) {
    if (options) {
      this.uuid = options.uuid;
      this.name = options.name;
      this.updatedAt = options.updatedAt && new Date(options.updatedAt);
      this.configuration = options.configuration;
      this.description = options.description;
      this.hasEnergyEfficiency = options.hasEnergyEfficiency;
      this.progress = options.progress; // not fed
      this.sizing = options.sizing;
      this.report = options.report;
    }
  }
}
